/* =============================================
   Free Shipping Bar JS — Exclosivo
   Actualización dinámica sin recarga de página
   ============================================= */

(function () {
  const THRESHOLD = 120000; // CLP — sin centavos

  function formatCLP(amount) {
    return '$' + amount.toLocaleString('es-CL');
  }

  function updateBar(cartTotal) {
    const bar = document.getElementById('free-shipping-bar');
    if (!bar) return;

    const remaining = Math.max(0, THRESHOLD - cartTotal);
    const progress = Math.min(100, Math.round((cartTotal / THRESHOLD) * 100));

    const fill = bar.querySelector('.free-shipping-bar__fill');
    const message = bar.querySelector('.free-shipping-bar__message');

    if (fill) fill.style.width = progress + '%';

    if (message) {
      if (cartTotal >= THRESHOLD) {
        message.className = 'free-shipping-bar__message free-shipping-bar__message--success';
        message.innerHTML = '🎉 ¡Felicidades! Tu pedido tiene <strong>envío gratis</strong>';
      } else {
        message.className = 'free-shipping-bar__message';
        message.innerHTML = `🚚 Te faltan <strong>${formatCLP(remaining)}</strong> para obtener envío gratis`;
      }
    }
  }

  function fetchCartAndUpdate() {
    fetch('https://exclosivo.store/cart.js')
      .then(r => r.json())
      .then(cart => {
        // En CLP Shopify devuelve el total sin centavos
        const total = cart.total_price / 100;
        updateBar(total);
      })
      .catch(console.error);
  }

  // Escuchar eventos nativos de Dawn
  document.addEventListener('cart:refresh', fetchCartAndUpdate);
  document.addEventListener('cart:updated', fetchCartAndUpdate);

  // Compatibilidad con el cart-drawer de Dawn (custom events)
  document.addEventListener('dispatch:cart-drawer:open', fetchCartAndUpdate);

  // MutationObserver como fallback para cuando Dawn actualiza el DOM del carrito
  const observer = new MutationObserver(() => {
    if (document.getElementById('free-shipping-bar')) {
      fetchCartAndUpdate();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Inicializar al cargar
  document.addEventListener('DOMContentLoaded', function() {
    fetchCartAndUpdate();
  });

})();
